import {CircleHelp} from 'lucide-react'
import {Button} from '@/components/ui/button'
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from '@/components/ui/tooltip'
import {useHelp} from '@/contexts/help-context'
import {useI18n} from '@/i18n'
import {cn} from '@/lib/utils'

/**
 * Header toggle button for the online help system.
 *
 * - Ghost button in inactive state; bg-primary/10 + text-primary when active.
 * - Tooltip: "Toggle help" (EN) / "Hilfe ein-/ausschalten" (DE).
 * - Persists preference to localStorage via HelpProvider.
 */
export function HelpToggleButton() {
    const i18n = useI18n()
    const {helpEnabled, toggleHelp} = useHelp()

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={toggleHelp}
                        aria-label={i18n.help.toggleHelp}
                        aria-pressed={helpEnabled}
                        className={cn(
                            helpEnabled && 'bg-primary/10 text-primary',
                        )}
                        data-testid="btn-help-toggle"
                    >
                        <CircleHelp className="h-4 w-4"/>
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    {i18n.help.toggleHelp}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}
